import { apiClient } from "@/shared/api/client";
import type { UpdateVenueProfilePayload, VenueProfile } from "@/features/venues/types";

export async function fetchMyVenue(): Promise<VenueProfile> {
  const { data } = await apiClient.get<VenueProfile>("/venues/me");
  return data;
}

export async function updateMyVenue(payload: UpdateVenueProfilePayload): Promise<VenueProfile> {
  const { data } = await apiClient.put<VenueProfile>("/venues/me", payload);
  return data;
}

export async function uploadMyVenueLogo(file: File): Promise<VenueProfile> {
  const form = new FormData();
  form.append("file", file);
  // Explicit multipart header — the apiClient default is application/json, which
  // would suppress axios's auto-boundary and cause FastAPI to reject the body
  // as "missing required field" (422).
  const { data } = await apiClient.post<VenueProfile>("/venues/me/logo", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function completeMyVenueOnboarding(): Promise<VenueProfile> {
  const { data } = await apiClient.post<VenueProfile>("/venues/me/complete-onboarding");
  return data;
}
